import { Box, keyframes, useTheme } from "@mui/material";

export const AnswerLoading = () => {
    const theme = useTheme();
    // Define a pulsing animation
    const pulse = keyframes`
    0% {
        transform: scale(1);
        opacity: 0.6;
    }
    50% {
        transform: scale(1.4);
        opacity: 1;
    }
    100% {
        transform: scale(1);
        opacity: 0.6;
    }
    `;

    return (
        <Box
            sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: theme.palette.primary.main,
                animation: `${pulse} 1s ease-in-out infinite`
            }}
        />
    );
};
